import { Outlet } from "react-router-dom";


interface IWinback {}

const Winback: React.FC<IWinback> = () => {
  return(
    <>
      <Outlet/>
    </>
  )
}

export default Winback;